export default __webpack_public_path__ + "static/media/annecy-hightlited-1x.f15b2b74.webp";